import React, {useEffect, useState} from 'react';
import {Skeleton} from "../skeleton/Skeleton";
import {useDispatch, useSelector} from "react-redux";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";
import {refresh} from "../../redux/slice/apiSlice";
import {
    TEXTAREA_AUTO_GROW_MAX_H,
    TEXTAREA_REMARK_MIN_H,
    useAutoResizeTextarea,
} from "./useAutoResizeTextarea";
import "./textareaAutoGrow.css";

function UpdateTextArea({target, required, listener, value, clicked, setClicked, style, auth, inform, sub}) {
    const [data, setData] =useState( value );
    const loading = useSelector(state => state.api.skeleton);
    const dispatch = useDispatch();
    useEffect(() => {
        if(required){
            data.setData(prev => ({
                ...prev,
                required_validate: { ...prev.required_validate, [target]: false }
            }));
        }
    }, [])
    const [updatedData, setUpdatedData] =useState();
    const {ref, syncHeight} = useAutoResizeTextarea(data, {
        minHeight: TEXTAREA_REMARK_MIN_H,
        maxHeight: TEXTAREA_AUTO_GROW_MAX_H,
    });

    const inputStyle = {
        backgroundColor: required && (!data || data.trim() === '') ? '#ffe5e5' : '',
        border: required && (!data || data.trim() ==='') ? '2px solid #e53939' : '',
        outline:'none',
        width : sub ? `calc(100% - ${sub}px)`: "100%",
        float : sub ? `left`: "",

};
    const basicStyle = {
        width : sub ? `calc(100% - ${sub}px)`:"100%" ,
        float : sub ? `left`: "",
        style
    };

    const handleChange = (event) => {
        if (event.keyCode === 13) {
            if (event.shiftKey) {
                return;
            } else {
                //엔터만 누르면 동적없음
                console.log("aaaa")
                event.preventDefault();
            }
        } else {

            setData(event.target.value);
            requestAnimationFrame(syncHeight);
        }
    };

    const keyDownHandler = async (event) => {
        if ( event.keyCode === 13 && !event.shiftKey) {
            event.preventDefault();
            if(required && data.trim() === ''){
                alert("필수값입니다.")
                return;
            }

            const response = await listener({id: target.id, fieldName:target.fieldName, value : data});
            if(response.status === 200){
                setUpdatedData(response.data)
                setClicked(false);
                handleActiveToast({message: "데이터가 수정되었습니다"});
            }else if(response.status === 403){
                handleActiveError({message: "권한이 없습니다."});
            }else{
                handleActiveError({message: "알 수 없는 에러 발생."});
            }

            dispatch(refresh(true))
        }

    }
    return (
        <>
        {!loading ?
            clicked && auth ?
                <textarea
                    ref={ref}
                    type={"text"}
                    className={`basic-input focus py-2 textarea-auto-grow`}
                    value={data}
                    onChange={e=>handleChange(e)}
                    style={required ? inputStyle : basicStyle}
                    onKeyDown={keyDownHandler}
                    autoFocus={true}
                    onBlur={()=>{
                        setClicked(false);
                        setData(updatedData ? updatedData :value)
                    }}
                />
                    :
                <div className={`line-h-30`}
                     style={{
                         ...basicStyle,
                         minHeight: TEXTAREA_REMARK_MIN_H,
                         maxHeight: TEXTAREA_AUTO_GROW_MAX_H,
                         overflowY: 'auto',
                     }}
                >
                    <span className={`edit-input ${!data && inform ? 'text-[#c16c6c] bold' :''}`}>
                        {data ?? inform}
                    </span>
                </div>
                :
                <Skeleton className={'w-full h-[30px]'}></Skeleton>
            }
        </>
    );
}

export default UpdateTextArea;